import type { RouteRecordRaw } from 'vue-router';

const LIMITED_FLOW_ROUTES = new Set([
    'login',
    'gcu',
    'login-reset-password',
    'login-two-factor-setup',
    'login-two-factor-verify',
]);

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('./components/LoginForm.vue'),
        meta: {
            title: 'AxeoBIM',
        },
        children: [
            {
                path: 'forgot-password',
                name: 'forgot-password',
                component: () => import('./components/ForgotPassword.vue'),
                beforeEnter: (to, from, next) => {
                    return from.name === 'login' ? next() : next({
                        name: 'login'
                    });
                },
            },
            {
                path: 'reset-password',
                name: 'login-reset-password',
                component: () => import('@/modules/header/components/modals/ResetPassword/ResetPasswordModal.vue'),
                meta: {
                    returnRoute: 'login',
                    closeTo: {
                        name: 'login'
                    },
                },
                beforeEnter: (to, from, next) => {
                    return LIMITED_FLOW_ROUTES.has(from.name as string) ? next() : next({
                        name: 'login'
                    });
                },
            },
            {
                path: 'two-factor-setup',
                name: 'login-two-factor-setup',
                component: () => import('@/modules/header/components/modals/TwoFactor/TwoFactorSetup.vue'),
                props: () => ({
                    authStep: false,
                }),
                meta: {
                    returnRoute: 'login',
                    closeTo: {
                        name: 'login'
                    },
                },
                beforeEnter: (to, from, next) => {
                    return LIMITED_FLOW_ROUTES.has(from.name as string) ? next() : next({
                        name: 'login'
                    });
                },
            },
            {
                path: 'two-factor-verify',
                name: 'login-two-factor-verify',
                component: () => import('@/modules/root/login/components/TwoFactorVerifyModal.vue'),
                meta: {
                    returnRoute: 'login',
                    closeTo: {
                        name: 'login'
                    },
                },
                beforeEnter: (to, from, next) => {
                    return LIMITED_FLOW_ROUTES.has(from.name as string) ? next() : next({
                        name: 'login'
                    });
                },
            },
            {
                path: 'account-bloqued',
                name: 'account-bloqued',
                component: () => import('./components/AccountBloqued.vue'),
                beforeEnter: (to, from, next) => {
                    return from.name === 'login' ? next() : next({
                        name: 'login'
                    });
                },
            },
            {
                path: 'gcu',
                name: 'gcu',
                component: () => import('./components/GCUModal.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    return LIMITED_FLOW_ROUTES.has(from.name as string) ? next() : next({
                        name: 'login'
                    });
                },
            },
        ],
    },
] satisfies RouteRecordRaw[];
